<template>
  <div class="koko">
    <line-chart-component
      class="koko"
      :chartOptions="chartOptions"
      :chartData="chartData"
    />
  </div>
</template>

<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  TimeScale
);

export default {
  name: "LineChart",
  components: {
    LineChartComponent: Line,
  },
  props: {
    chartData: Object,
  },
  computed:{
    chartOptions() {
      return{

        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {},
        scales: {
          y: {
            title: {
              display: true,
              text: "Ciclos",
            },
ticks: {
              font: {
                size: 25,
              }
            },
            min: 0,
            max: this.chartData?.max ? this.chartData?.max : null,
          },
          x: {
            type: "time",
            title: {
              display: true,
              text: "Hora",
            },
ticks: {
              font: {
                size: 25,
              }
            },
            time: {
              unit: "hour",
              tooltipFormat: "yyyy-MM-dd HH:mm:ss",
              displayFormats: {
                hour: "HH:mm",
              },
            },
          },
        },
        interaction: {
          mode: "index",
          intersect: false,
        },
        elements: {
          point: {
            radius: 0,
          },
        },
      }
      },
  },
  data() {
    return {
    };
  },
};
</script>
<style scoped>
.chart-wrapper {
  width: 100%; /* Asegura que el contenedor ocupe todo el ancho disponible */
  height: 100%; /* Asegura que ocupe toda la altura del contenedor padre */
}

.chart-wrapper canvas {
  width: 100% !important; /* Asegura que el canvas ocupe todo el ancho */
  height: 100% !important; /* Asegura que el canvas ocupe todo el alto */
  box-sizing: border-box; /* Asegura que el padding no afecte el tamaño */
}
.koko{
  height: 100%;
}
</style>
